/** @format */

import useGa4PageView from 'src/hooks/useGa4PageView';

export default function Ga4PageViewTracker() {
  useGa4PageView();
  return null;
}
